import React, { useState, useEffect } from 'react';
import "../../../../css/classes/annualView.scss"
const BudgetSummary = () => {
 
  const [animateCards, setAnimateCards] = useState(false);
  const [animateProgress, setAnimateProgress] = useState(false);

  useEffect(() => {
    // Trigger animations after component mounts
    setTimeout(() => setAnimateCards(true), 100);
    setTimeout(() => setAnimateProgress(true), 500);
  }, []);

  const marchData = {
    previousBalance: { actual: 500.00, excess: 500.00 },
    income: { actual: 5350.00, budget: 5150.00, percentage: 104, remaining: 0.00, excess: 200.00 },
    expenses: { actual: 2810.00, budget: 2600.00, percentage: 108, remaining: 0.00, excess: 210.00 },
    bills: { actual: 57.00, budget: 96.00, percentage: 59, remaining: 39.00, excess: 0.00 },
    debts: { actual: 900.00, budget: 800.00, percentage: 113, remaining: 0.00, excess: 100.00 },
    savings: { actual: 1364.00, budget: 1654.00, percentage: 82, remaining: 290.00, excess: 0.00 },
    amountLeft: 719.00,
    remainingBudget: -329.00,
    totalExcess: 390.00,
    spendingRate: 89,
    savingRate: 11,
    allocatedSavings: 1364.00
  };

  const aprilData = {
    previousBalance: { actual: 719.00, excess: 719.00 },
    income: { actual: 6350.00, budget: 5050.00, percentage: 126, remaining: 0.00, excess: 1300.00 },
    expenses: { actual: 2600.00, budget: 2600.00, percentage: 100, remaining: 0.00, excess: 0.00 },
    bills: { actual: 10.00, budget: 96.00, percentage: 10, remaining: 86.00, excess: 0.00 },
    debts: { actual: 300.00, budget: 800.00, percentage: 38, remaining: 500.00, excess: 0.00 },
    savings: { actual: 1550.00, budget: 1554.00, percentage: 100, remaining: 4.00, excess: 0.00 },
    amountLeft: 2609.00,
    remainingBudget: -590.00,
    totalExcess: 2019.00,
    spendingRate: 91,
    savingRate: 9,
    allocatedSavings: 1550.00
  };

  const getIcon = (type) => {
    const icons = {
      'Previous Balance': 'fa-wallet',
      'Income': 'fa-arrow-up',
      'Expenses': 'fa-arrow-down',
      'Bills': 'fa-file-text-o',
      'Debts': 'fa-credit-card',
      'Savings': 'fa-piggy-bank'
    };
    return icons[type] || 'fa-circle';
  };

  const getPercentageColor = (percentage, type) => {
    if (type === 'Income') return percentage >= 100 ? '#10b981' : '#ef4444';
    if (type === 'Bills' || type === 'Expenses' || type === 'Debts') {
      return percentage <= 100 ? '#10b981' : '#ef4444';
    }
    return percentage >= 80 ? '#10b981' : '#f59e0b';
  };

  const renderBudgetCard = (title, data, isAnimated) => (
    <div className={`budget-card ${isAnimated ? 'animate-in' : ''}`}>
      <div className="budget-summary-card-header">
       
        <h2 className="card-title">SUMMARY</h2>
       </div>
      
      <div className="month-header">
        <h3>{title}</h3>
      </div>

      <div className="table-container">
        <table className="budget-table">
          <thead>
            <tr>
              <th>Type</th>
              <th>Actual</th>
              <th>Budget</th>
              <th>(%)</th>
              <th>Remaining</th>
              <th>Excess</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries({
              'Previous Balance': data.previousBalance,
              'Income': data.income,
              'Expenses': data.expenses,
              'Bills': data.bills,
              'Debts': data.debts,
              'Savings': data.savings
            }).map(([type, values], index) => (
              <tr key={type} style={{ animationDelay: `${index * 0.1}s` }}>
                <td className="type-cell">
                  <i className={`fa ${getIcon(type)} type-icon`}></i>
                  {type} {type !== 'Previous Balance' && (
                    <span className="type-indicator">
                      {type === 'Income' ? '(+)' : 
                       type === 'Savings' ? '(-)' : 
                       type === 'Expenses' || type === 'Bills' || type === 'Debts' ? '(-)' : ''}
                    </span>
                  )}
                  {type === 'Income' && <i className="fa fa-caret-up trend-up"></i>}
                  {(type === 'Expenses' || type === 'Savings') && <i className="fa fa-caret-down trend-down"></i>}
                  {type === 'Bills' && <i className="fa fa-caret-down trend-down"></i>}
                </td>
                <td className="amount">₹ {values.actual?.toFixed(2) || '-'}</td>
                <td className="budget">
                  {values.budget ? `₹ ${values.budget.toFixed(2)}` : '-'}
                </td>
                <td className="percentage">
                  {values.percentage ? (
                    <div className="percentage-container">
                      <div 
                        className="percentage-bar"
                        style={{ 
                          backgroundColor: getPercentageColor(values.percentage, type),
                          width: animateProgress ? '100%' : '0%'
                        }}
                      >
                        {values.percentage}%
                      </div>
                    </div>
                  ) : '-'}
                </td>
                <td className="remaining">
                  {values.remaining !== undefined ? `₹ ${values.remaining.toFixed(2)}` : '-'}
                </td>
                <td className="excess">
                  {values.excess !== undefined ? `₹ ${values.excess.toFixed(2)}` : '-'}
                </td>
              </tr>
            ))}
            <tr className="amount-left-row">
              <td className="type-cell"><strong>Amount Left</strong></td>
              <td className="amount amount-left">₹ {data.amountLeft.toFixed(2)}</td>
              <td>₹ 0.00</td>
              <td>-</td>
              <td>₹ {data.remainingBudget.toFixed(2)}</td>
              <td className="excess-positive">₹ {data.totalExcess.toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="overview-section">
        <div className="overview-header">
          <span>Overview</span>
        </div>
        
        <div className="metrics-container">
          <div className="metric-item">
            <div className="metric-header">
              <i className="fa fa-caret-right"></i>
              <span>Spending Rate</span>
            </div>
            <div className="metric-value spending-rate">{data.spendingRate}%</div>
            <div className="metric-amount">₹ {(data.income.actual * data.spendingRate / 100).toFixed(2)}</div>
          </div>

          <div className="metric-item">
            <div className="metric-header">
              <i className="fa fa-caret-right"></i>
              <span>Saving Rate</span>
            </div>
            <div className="metric-value saving-rate">{data.savingRate}%</div>
            <div className="metric-subtext">% allocated to Savings</div>
            <div className="metric-amount">₹ {data.allocatedSavings.toFixed(2)}</div>
          </div>
        </div>

        {/* <div className="transactions-link">
          <span>go to transactions</span>
          <i className="fa fa-caret-right"></i>
        </div> */}
      </div>
            </div>
  );

  return (
    <>
      
      <div className="budget-dashboard">
      <div className="cards-container">
        {renderBudgetCard('March 2023', marchData, animateCards)}
        {renderBudgetCard('April 2023', aprilData, animateCards)}
      </div>
    </div>
    </>
  );
};

export default BudgetSummary;